import React from 'react';
import type ServicedeskQueuesLandingType from '@atlassian/jira-spa-apps-servicedesk-queues-landing/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesLanding = lazyForPaint<typeof ServicedeskQueuesLandingType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-landing", jiraSpaEntry: "async-servicedesk-queues-landing" */ '@atlassian/jira-spa-apps-servicedesk-queues-landing'
		),
);

const AsyncServicedeskQueuesLanding = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskQueuesLanding}
		pageId="spa-apps/servicedesk/queues/landing"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskQueuesLanding;
